<template>
  <div class="hello">
    <sui-button floated="left" content="Back" icon="backward" @click="$router.go(-1)" />
    <!--<sui-button floated="right" content="Refresh" icon="refresh" v-on:click="refresh()" />-->
    <div v-if="device">
        <h1>Device {{ device.deviceId }} (deactivated)</h1>
        
        <sui-grid>
            <sui-grid-row>
                <sui-grid-column>
                    <h3 is="sui-header" attached="top">Data</h3>
                    <sui-segment attached>
                        <p>Available data: {{ device.timestamp | moment('HH:mm:ss D. M. Y') }} - {{ device.timestampEnd | moment('HH:mm:ss D. M. Y') }}</p>
                        <ListHistory :deviceId="device.deviceId" :end="device.timestampEnd" />
                    </sui-segment>
                </sui-grid-column>
            </sui-grid-row>
            <sui-grid-row :columns="2">
                <sui-grid-column>
                    
                    <h3 is="sui-header" attached="top"><sui-button floated="right" content="Go to channel" icon="eye" v-on:click="$router.push({ name: 'alias_detail', params: { id: device.deviceAttributes.alias } })" size="mini" />Channel</h3>
                    
                    <sui-segment attached>
                        <p>Last known channel: <strong>{{ device.deviceAttributes.alias }}</strong></p>
                    </sui-segment>
                </sui-grid-column>
                <sui-grid-column v-if="device.deviceAttributes.parameters">
                    <h3 is="sui-header" attached="top">Last parameters</h3>
                    <sui-segment attached>
                        <ParametersTable :parameters="device.deviceAttributes.parameters"/>
                    </sui-segment>
                </sui-grid-column>
            </sui-grid-row>
        </sui-grid>
        
        
    </div>
    <div v-else>
        <h1>...</h1>
    </div>
    
    
  </div>
</template>

<script>
import DziService from '@/DziService'
import ListHistory from '@/components/Device/ListHistory.vue';
import ParametersTable from '@/components/Device/ParametersTable.vue';


export default {
  name: 'DeviceDetailInactive',
  data () {
        return {
            device: null,
        }
    },  
  props: {
//    msg: String
  },
  methods: {
        refresh() {
          this.device = null;
          this.getDeactivatedDevice();  
        },
        async getDeactivatedDevice () {
            const response = await DziService.getDeactivatedDevice(this.$route.params.id, this.$route.params.timestamp)
            this.device = response.data;
        },
    },
    mounted () {
        this.getDeactivatedDevice();
        },
        components: {
            ListHistory,
            ParametersTable
        }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
